import { LatLngExpression } from 'leaflet';

export interface MeetingRoomCoordinate {
    id: string;
    name: string;
    polygon: LatLngExpression[];
    status: 'OCCUPIED' | 'AVAILABLE' | 'RESERVED';
    code?: string;
}

export const ROOM_COORDINATES: Record<string, MeetingRoomCoordinate[]> = {
    '14': [
        { id: 'room-1410', name: '403-10人會議室', polygon: [[761, 458], [761, 548], [644, 522], [644, 458]], status: 'AVAILABLE', code: 'PANEL_45' },
        { id: 'room-1411', name: '404-8人會議室', polygon: [[761, 655], [761, 730], [644, 730], [644, 655]], status: 'AVAILABLE', code: 'PANEL_42' },
        { id: 'room-1412', name: '401-16人會議室', polygon: [[761, 730], [761, 883], [620, 883], [620, 730]], status: 'AVAILABLE', code: 'PANEL_41' },
        { id: 'room-1413', name: '402-10~16人會議室', polygon: [[881, 736], [881, 863], [763, 863], [763, 736]], status: 'AVAILABLE', code: 'PANEL_40' },
        { id: 'room-1414', name: '406-4人會議室', polygon: [[881, 677], [881, 735], [810, 735], [810, 677]], status: 'AVAILABLE', code: 'PANEL_43' },
        { id: 'room-1415', name: '405-6人會議室', polygon: [[640, 887], [640, 970], [565, 970], [565, 887]], status: 'AVAILABLE', code: 'PANEL_44' },
    ],
    '15': [
        { id: 'room-1504', name: '501-RiverRoom', polygon: [[687, 456], [687, 589], [603, 589], [603, 456]], status: 'AVAILABLE', code: 'PANEL_50' },
        { id: 'room-1506', name: '504-MountainRoom', polygon: [[800, 663],[800, 739], [720, 739], [720, 663]], status: 'AVAILABLE', code: 'PANEL_49' },
        { id: 'room-1507', name: '503-ForestRoom', polygon: [[898, 663],[898,768], [800, 768], [800, 663]], status: 'AVAILABLE', code: 'PANEL_48' },
        { id: 'room-1508', name: '502-OceanRoom', polygon: [[898, 768],[898,870], [800, 870], [800, 768]], status: 'AVAILABLE', code: 'PANEL_47' },
        { id: 'room-1510', name: '505-EarthRoom', polygon: [[547, 519], [547, 598], [474, 598], [474, 519]], status: 'AVAILABLE', code: 'PANEL_46' },
    ]
};
